import React from 'react';
import CRUDManager from '../../../shared/components/crud/CRUDManager';
import { medicalStaffConfig } from '../config/medicalStaffConfig';

export default function MedicalStaff() {
  return <CRUDManager config={medicalStaffConfig} />;
}